import { createTheme } from '@mui/material/styles';
import { ArrowDown2 } from 'iconsax-react';
import { CustomToolbar } from './components/common/CustomToolbar';

const primaryMain = '#0048E5';
const primaryLight = '#4A90E2'; // Brighter, more vibrant blue
const primaryDark = '#003BB3';  // Darker blue for hover states
const secondaryMain = '#592e12';
const disabledColor = '#cacacd';
const disabledColorDark = '#4a4a4d';
const backgroundGrayToggleHeader = '#a0a0a0ff';

const getCommonComponents = (theme) => ({
  MuiCssBaseline: {
    styleOverrides: {
      '::-webkit-scrollbar': {
        width: '10px !important',
        height: '10px'
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '10px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#555',
      },
      '::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2c2c2c' : '#f1f1f1',
      },
      // ✅ Custom global <textarea> style
      textarea: {
        backgroundColor: theme.palette.mode === 'dark'
          ? theme.palette.background.paper
          : '#ffffff',
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.mode === 'dark'
            ? theme.palette.customColors.border
            : '#ccc'
          }`,
        borderRadius: '4px',
        padding: '8px',
        fontFamily: 'inherit',
        lineHeight: 1.5,
        resize: 'vertical',
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        backgroundColor: backgroundGrayToggleHeader,
        marginRight: 5,
        marginBottom: 5,
        padding: 0,
        "&.Mui-selected": {
          background: theme.palette.mode === 'dark' ? 'linear-gradient(135deg, #1E88E5 0%, #1976D2 100%)' : 'linear-gradient(90deg, #0048E5 0%, #003BB3 100%)',
          color: 'white',
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.mode === 'dark' ? 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)' : 'linear-gradient(90deg, #003BB3 0%, #002884 100%)',
          color: 'black',
        },
        "&:hover": {
          backgroundColor: theme.palette.mode === 'dark' ? 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)' : 'linear-gradient(90deg, #003BB3 0%, #002884 100%)',
          color: theme.palette.mode === 'dark' ? 'white' : 'black',
        },
        //   "&.Mui-disabled": {
        //   backgroundColor: theme.palette.mode === 'dark' ? '#424242' : disabledColor,
        //   color: 'white', // ✅ force white text
        //   boxShadow: 'none',
        // }

      }
    }
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        minHeight: 'unset',
        overflow: 'visible',
        background: theme.palette.mode === 'dark' ? '#083b68ff' : 'rgba(0, 72, 229, 0.10);',
        textTransform: 'none',
        fontWeight: 'bold',
        color: theme.palette.mode === 'dark' ? '#ffffff' : '#222222', // Use your theme colors
        '&.Mui-selected': {
          color: theme.palette.mode === 'dark' ? '#1E88E5' : '#0048E5',
        }
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        padding: "0px 16px",
        margin: "10px 0px",
        minHeight: 'unset',
        textTransform: 'none',
        fontWeight: 'bold'
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        padding: "5px 8px",
      },
    },
  },
  MuiListItemText: {
    styleOverrides: {
      root: {
        minWidth: 'unset',
        maxWidth: 'unset',
        minHeight: 'unset',
        whiteSpace: 'nowrap',
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        padding: "0 2px",
      },
    },
  },
  MuiPopover: {
    defaultProps: {
      marginThreshold: 0,
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      option: {
        padding: '0 2px !important',
      }
    },
    defaultProps: {
      popupIcon: <ArrowDown2 size={20} color={theme.palette.main} />
    }
  },
  // MuiButton: {
  //   styleOverrides: {
  //     root: {
  //       background: theme.palette.mode === 'dark' 
  //         ? 'linear-gradient(135deg, #1E88E5 0%, #3F51B5 40%)' 
  //         : 'linear-gradient(90deg, #0048E5 0%, #625AF5 85%)',
  //       color: '#fff',
  //       textTransform: 'none',
  //       lineHeight: 'unset',
  //       fontWeight: 500,
  //       borderRadius: '6px',
  //       boxShadow: theme.palette.mode === 'dark' 
  //         ? '0 2px 8px rgba(30, 136, 229, 0.3)' 
  //         : '0 2px 4px rgba(0, 72, 229, 0.2)',
  //       transition: 'all 0.2s ease-in-out',
  //       "&:hover": {
  //         background: theme.palette.mode === 'dark'
  //           ? 'linear-gradient(135deg, #1976D2 0%, #3949AB 50%)'
  //           : 'linear-gradient(90deg, #003BB3 0%, #746fdaff 85%)',
  //         boxShadow: theme.palette.mode === 'dark' 
  //           ? '0 4px 12px rgba(30, 136, 229, 0.4)' 
  //           : '0 4px 8px rgba(0, 72, 229, 0.3)',
  //         transform: 'translateY(-1px)',
  //       },
  //       "&.Mui-disabled": {
  //         background: theme.palette.mode === 'dark' ? '#424242' : disabledColor,
  //         color: theme.palette.mode === 'dark' ? "#888888" : "white",
  //         boxShadow: 'none',
  //         transform: 'none',
  //       }
  //     }
  //   },
  //   defaultProps: {
  //     size: 'small',
  //   },
  // },
  MuiButton: {
    styleOverrides: {
      root: {
        background: theme.palette.mode === 'dark'
          ? 'linear-gradient(135deg, #1e88e5ff 0%, #1976D2 100%)'
          //  : 'linear-gradient(90deg, #0048E5 0%, #003BB3 100%)',
          : 'linear-gradient(90deg, #0048E5 0%, #625AF5 85%, #7162FC 100%)',
        color: '#fff',
        textTransform: 'none',
        lineHeight: 'unset',
        fontWeight: 500,
        borderRadius: '6px',
        border: 'none',
        boxShadow: theme.palette.mode === 'dark'
          ? '0 1px 3px rgba(30, 136, 229, 0.15)'
          : '0 1px 3px rgba(0, 72, 229, 0.15)',
        transition: 'all 0.15s ease',
        "&:hover": {
          background: theme.palette.mode === 'dark'
            ? 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)'
            : 'linear-gradient(90deg, #0048E5 0%, #625AF5 85%, #7162FC 100%)',
          // : 'linear-gradient(90deg, #003BB3 0%, #002884 100%)',
          boxShadow: theme.palette.mode === 'dark'
            ? '0 2px 4px rgba(30, 136, 229, 0.2)'
            : '0 2px 4px rgba(0, 72, 229, 0.2)',
        },
        "&.Mui-disabled": {
          background: theme.palette.mode === 'dark' ? '#424242' : disabledColor,
          color: theme.palette.mode === 'dark' ? "#ffff" : "black",
          boxShadow: 'none',
        }
      }
    },
    defaultProps: {
      size: 'small',
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        minWidth: 'unset',
        maxWidth: 'unset',
        minHeight: 'unset',
        whiteSpace: 'nowrap',
        backgroundColor: theme.palette.mode === 'dark' ? '#2b2b2b' : '#ffffff',
        '& .MuiInputBase-root': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2b2b2b' : '#ffffff',
          color: theme.palette.text.primary,
        },
        '& .MuiSvgIcon-root': {
          fontSize: 16,
        },
      },
    },
    defaultProps: {
      SelectProps: {
        MenuProps: {
          sx: {
            maxHeight: '300px !important',
          },
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        fontFamily: 'Montserrat, sans-serif',
        backgroundColor: theme.palette.mode === 'dark' ? '#333333' : '#E7E7E7',
        borderRadius: '18px',
        display: 'flex',
        alignItems: 'center',
        padding: '4px 6px',
        gap: '8px',
        color: '#333333',
        '& .MuiChip-deleteIcon': {
          cursor: 'pointer',
          borderRadius: '18px',
          padding: '3px',
          margin: 0,
          backgroundColor: 'rgba(136, 136, 136, 0.40);',
          color: theme.palette.text.primary,
          '&:hover': {
            color: '#616161',
          },
        },
      },
    },
  },
  // MuiCheckbox: {
  //   defaultProps: {
  //     size: 'small',
  //   },
  //   styleOverrides: {
  //     root: {
  //       padding: '2px 8px',
  //     }
  //   }
  // },
  MuiCheckbox: {
    defaultProps: {
      size: 'small',
    },
    styleOverrides: {
      root: ({ theme }) => ({
        padding: '2px 8px',
        color:
          theme.palette.mode === 'dark'
            ? theme.palette.grey[400]
            : theme.palette.grey[600],
        '&.Mui-disabled': {
          color:
            theme.palette.mode === 'dark'
              ? '#424242' // Dark mode disabled
              : '#cacacd', // Light mode disabled
        },
      }),
    },
  },
  MuiRadio: {
    defaultProps: {
      size: 'small',
    },
    styleOverrides: {
      root: {
        padding: '2px 8px'
      }
    }
  },
  MuiSelect: {
    styleOverrides: {
      select: {
        padding: '4px',
        background: theme.palette.mode === 'dark' ? '#2b2b2b' : '#FFF',
        fontSize: '13px',
        color: theme.palette.text.primary,
      },
      icon: {
        top: 'auto'
      }
    },
    defaultProps: {
      SelectProps: {
        MenuProps: {
          sx: {
            maxHeight: '300px',
            fontSize: '13px'
          },
          PaperProps: {
            sx: {
              maxHeight: '200px',
              overflowY: 'auto',
              fontSize: '13px'
            }
          }
        },
      },
      IconComponent: (props) => (<ArrowDown2 {...props} color={theme.palette.mode === 'dark' ? 'white' : 'blue'} size={20} />)
    },
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        padding: '4px',
        background: theme.palette.mode === 'dark' ? '#2b2b2b' : '#FFF',
        fontSize: '13px',
        color: theme.palette.text.primary
      },
      root: {
        background: theme.palette.mode === 'dark' ? '#2b2b2b' : '#FFF',
        paddingRight: '5px',
        color: theme.palette.text.primary
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        padding: '4px',
        background: theme.palette.mode === 'dark' ? '#2b2b2b' : '#FFF',
        fontSize: '13px',
        color: theme.palette.text.primary
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        size: "small",
        minWidth: 'unset',
        maxWidth: 'unset',
        whiteSpace: 'nowrap',
        padding: '0px 8px',
        textAlign: 'left',
        verticalAlign: 'middle',
        lineHeight: 'unset',
        border: theme.palette.customColors.border,
        color: theme.palette.text.primary
      },
    },
  },
  MuiTable: {
    styleOverrides: {
      root: {
        width: 'auto',
        tableLayout: 'auto',
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        "& th": {
          backgroundColor: theme.palette.mode === 'dark' ? '#333333' : 'rgba(0, 72, 229, 0.10)',
        }
      }
    }
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        fontWeight: 'bold',
        padding: 1,
      }
    }
  },
  MuiPickersPopper: {
    styleOverrides: {
      root: {
        fontFamily: 'Montserrat, sans-serif',
      }
    }
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      root: {
        fontFamily: 'Montserrat, sans-serif',
      },
      label: {
        fontFamily: 'Montserrat, sans-serif',
      }
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        fontFamily: 'Montserrat, sans-serif',
        "&.Mui-selected": {
          backgroundColor: theme.palette.mode === 'dark' ? '#1E88E5' : primaryMain,
          color: 'white',
          "&:hover": {
            backgroundColor: theme.palette.mode === 'dark' ? '#1976D2' : primaryDark,
          }
        },
        "&:hover": {
          backgroundColor: theme.palette.mode === 'dark' ? '#1976D2' : primaryDark,
          color: 'white',
        }
      }
    }
  },
  MuiDayCalendar: {
    styleOverrides: {
      header: {
        fontFamily: 'Montserrat, sans-serif',
      },
      weekDayLabel: {
        fontFamily: 'Montserrat, sans-serif',
      }
    }
  },
  MuiPickersYear: {
    styleOverrides: {
      root: {
        fontFamily: 'Montserrat, sans-serif',
      }
    }
  },
  MuiPickersMonth: {
    styleOverrides: {
      root: {
        fontFamily: 'Montserrat, sans-serif',
      }
    }
  },
  MuiTablePagination: {
    styleOverrides: {
      root: {
        maxHeight: 30,
      }
    }
  },
  MuiToolbar: {
    styleOverrides: {
      dense: {
        height: 32,
        minHeight: 32
      }
    }
  },
  MuiFormControlLabel: {
    styleOverrides: {
      label: {
        fontSize: '13px'
      }
    }
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        border: theme.palette.mode === 'dark' ? '1px solid #444444' : '1px solid rgba(220, 220, 220, 0.80)',
        '& .MuiDataGrid-cell': {
          border: theme.palette.mode === 'dark' ? '1px solid #444444' : '1px solid #e0e0e0',
          textAlign: 'left',
          fontSize: '13px',
          background: theme.palette.mode === 'dark' ? '#2b2b2b' : '#FFF',
          color: theme.palette.text.primary,
          '&.positive-cell': {
            color: '#009211',
            background: 'rgba(0, 146, 17, 0.10)',
          },
          '&.negative-cell': {
            color: '#FF0000',
            background: 'rgba(255,0, 0, 0.05)',
          },
          '&.brown-cell': {
            color: 'rgb(139 75 60)',
            background: 'rgb(255,160,85, 0.2)'
          },
        },
        '& .MuiDataGrid-columnHeader': {
          borderRight: theme.palette.mode === 'dark' ? '1px solid #444444' : '1px solid #e0e0e0',
          borderBottom: theme.palette.mode === 'dark' ? '1px solid #444444' : '1px solid rgba(0, 0, 0, 0.20)',
          fontSize: '13px',
          textAlign: 'left',
          color: theme.palette.text.primary,
          fontWeight: 600,
          backgroundColor: theme.palette.mode === 'dark' ? '#333333' : 'rgba(246, 246, 246, 0.80)'
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 600,
        },
        '& .MuiDataGrid-footerContainer': {
          maxHeight: 30,
          minHeight: 30,
          borderTop: theme.palette.mode === 'dark' ? '1px solid #444444' : '1px solid #e0e0e0'
        },
        '& .aggregatedrow': {
          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(66, 47, 31, 0.20) !important' : 'rgba(43, 25, 10, 0.10) !important',
        },
        '& .total-row': {
          backgroundColor: theme.palette.mode === 'dark' ? '#333333' : '#f5f5f5',
          fontWeight: 'bold'
        },
        '& .MuiButtonBase-root': {
          padding: '0px'
        },
        ' & .MuiDataGrid-pinnedRows': {
          width: 'fit-content',
          border: `3px solid ${primaryMain}`,
        },
        '& .MuiDataGrid-pinnedRows .MuiDataGrid-row': {
          width: '100%',
          marginRight: '-16px',
        },
        '& .MuiDataGrid-scrollbar--vertical': {
          width: '10px !important',
        },
        '& .MuiDataGrid-scrollbar--horizontal': {
          height: '10px !important',
        },
      }
    },
    defaultProps: {
      rowHeight: 30,
      hideFooter: true,
      keepNonExistentRowsSelected: true,
      columnHeaderHeight: 35,
      resizeThrottleMs: 120,
      autosizeOnMount: {
        autosizeOptions: {
          includeHeaders: true,
          includeOutliers: true,
          expand: true,
        },
      },
      columnBufferPx: 5000,
      initialState: {
        density: "standard",
      },
      slots: {
        toolbar: CustomToolbar
      }
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        color: theme.palette.primary,
        background: 'transparent'
      }
    },
    defaultProps: {
      size: '24px'
    }
  }
});

const baseDarkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#ffff', light: '#4A90E2', dark: '#1976D2' }, // Vibrant blues like Yes Energy
    secondary: { main: secondaryMain },
    action: {
      disabledBackground: disabledColor,
      disabled: disabledColor
    },
    disabledColor: { main: disabledColorDark },
    backgroundGrayToggleHeader: { main: backgroundGrayToggleHeader },
    background: {
      default: '#1a1a1a', // Similar to Yes Energy's main background
      paper: '#2b2b2b',   // Elevated surfaces like Yes Energy's panels
    },
    text: {
      primary: '#ffffff',    // Pure white text like Yes Energy for maximum contrast
      secondary: '#d6d6d6ff',  // Light gray for secondary text
    },
    customColors: {
      mainColor: 'linear-gradient(135deg, #1E88E5 0%, #1976D2 100%)', // Modern gradient for dark theme
      headerBlue: '#333333',  // Dark gray headers like Yes Energy
      contrast: '#ffffff',
      altopColor: '#EF7F1A',
      pnlRed: '#FF0000',
      pnlGreen: '#00C851', // Slightly brighter green for better visibility
      border: '1px solid #444444', // Subtle but visible borders like Yes Energy
      darkBackground: {
        dark: '#0f0f0f',  // Very dark for deepest elements
        borderColor: '1px solid #444444',
      },
      mediumBackground: '#333333', // Medium gray for elevated elements
      lightBackground: '#2b2b2b',  // Light surfaces within dark theme
    },
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 13,
    body1: { fontSize: '13px' },
  },
});

baseDarkTheme.components = getCommonComponents(baseDarkTheme);
export const darkTheme = baseDarkTheme;

const baseLightTheme = createTheme({
  palette: {
    primary: { main: primaryMain, light: primaryLight },
    secondary: { main: secondaryMain },
    action: {
      disabledBackground: disabledColor,
      disabled: disabledColor
    },
    disabledColor: { main: disabledColor },
    backgroundGrayToggleHeader: { main: backgroundGrayToggleHeader },
    text: {
      primary: '#222222',
      secondary: '#616161',
    },
    customColors: {
      mainColor: 'linear-gradient(90deg, #0048E5 0%, #625AF5 85%)',
      headerBlue: 'rgba(0, 72, 229, 0.10)',
      contrast: '#000000',
      altopColor: '#EF7F1A',
      pnlRed: '#FF0000',
      pnlGreen: '#009211',
      border: '1px solid rgba(220, 220, 220, 0.80)',
      darkBackground: {
        dark: 'rgba(209, 209, 209, 0.60)',
        borderColor: '1px solid rgba(136, 136, 136, 0.20)',
      },
      mediumBackground: '#e3e3e3',
      lightBackground: '#f6f6f6',
    },
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 13,
    body1: { fontSize: '13px' },
  },
});

baseLightTheme.components = getCommonComponents(baseLightTheme);

export const lightTheme = baseLightTheme;